import React, { useEffect, useState } from "react";
import { api, downloadFile } from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { StatusBadge } from "@/components/StatusBadge";
import { Card, Btn, Empty } from "@/components/ui-kit";
import { Download } from "lucide-react";

export default function Imports() {
  const [logs, setLogs] = useState([]);

  useEffect(() => { api.get("/import-logs").then((r) => setLogs(r.data)); }, []);

  return (
    <div>
      <PageHeader title="Import Centre" subtitle="All upload activity, templates and error files"
        actions={<>
          <Btn variant="outline" onClick={() => downloadFile("/import-templates/payroll", "payroll_template.xlsx")} data-testid="tpl-payroll"><Download size={15} /> Payroll Template</Btn>
          <Btn variant="outline" onClick={() => downloadFile("/import-templates/employee", "employee_template.xlsx")} data-testid="tpl-employee"><Download size={15} /> Employee Template</Btn>
        </>} />

      <Card className="overflow-hidden">
        <div className="overflow-x-auto">
          {logs.length ? (
            <table className="nk-table" data-testid="imports-table">
              <thead><tr>
                <th>Type</th><th>Client</th><th>Month</th><th>File</th><th>Uploaded By</th><th>Uploaded At</th>
                <th>Total</th><th>Valid</th><th>Warnings</th><th>Errors</th><th>Status</th>
              </tr></thead>
              <tbody>
                {logs.map((l) => (
                  <tr key={l.id} data-testid={`import-log-${l.id}`}>
                    <td className="font-medium">{l.type}</td><td>{l.client_name}</td>
                    <td className="nk-num">{l.month || "—"}</td><td className="text-slate-500">{l.filename}</td>
                    <td>{l.uploaded_by}</td><td className="nk-num text-slate-500">{(l.created_at || "").slice(0, 16).replace("T", " ")}</td>
                    <td className="nk-num">{l.total_rows}</td><td className="nk-num text-emerald-600">{l.valid_rows}</td>
                    <td className="nk-num text-amber-600">{l.warning_rows}</td><td className="nk-num text-red-600">{l.error_rows}</td>
                    <td><StatusBadge status={l.error_rows ? "overdue" : "finalized"} /></td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : <Empty title="No imports yet" hint="Upload payroll or employee files to see history here." />}
        </div>
      </Card>
    </div>
  );
}
